import React from 'react';
import './HomePage.css';

// Components
import Landing from "../components/LandingPage";
import ProjectsDisplay from "../components/NoctemProjects";
import AboutInfoBlock from "../components/AboutInfo";
// import AnnouncementBanner from "../components/AnnouncementBanner";
import PartnersSlideshow from "../components/PartnersSlides";
import EmailButton from "../components/EmailButton";
import SocialMediaSection from "../components/SocialMedia";
// import MapDisplay from "../components/Map";
// import ServicesSection from "../components/Service";

// Logo
import crpNoctemLogo from '../content/CRPLOGO-removebg.png';


function LandingSection(){

  return(
    <div>
      <Landing />
    </div>
  )

}

function DisplayProjects() {

  return (
  <div>
    <ProjectsDisplay />
  </div>
  );
}

function AboutSection(){

  return(
    <div >
      <AboutInfoBlock />
    </div>
  );
}



// function Services() {
//   return (
//     <div className="home-page">
//       <div className="home-container">
//         <h1 className="home-title">Welcome to Our Company</h1>
//         <p className="home-description">We offer live events, web development, and production services.</p>
//         <Link to="/portal">
//           <button className="home-portal-btn">Access Service Portal</button>
//         </Link>
//       </div>
//     </div>
//   );
// }


function Partners(){


  return(
        <div className="App">
      {/* Other sections of your app */}
      <PartnersSlideshow />
      {/* Other sections of your app */}
    </div>

  )
}

// function Map(){

//   return(
//     <div>
//       <MapDisplay />
//     </div>
//   )
// }


function Socials(){
  
  return(
    <div className="App">
      <h1>Follow Us</h1>
      <SocialMediaSection />
    </div>
  );
};



function Footer(){

  return(
    <div className='footer'>
      <footer className='footer-block'>
        
        <div className='footer-block-section'>
          <img className='footer-img'
          src={crpNoctemLogo}
          alt='CRP NOCTEM' />
        </div>
        
        <div className='footer-email-button'>          
        <div className="footer-email-button">
          <EmailButton />
        </div>

        </div>
        
      </footer>
      <div className='footer-text-section'>
          <p className='footer-text'>CRP Noctem @2025</p>
    </div>
    </div>
  )
}


function Home(){

  return(
    <div>
      <LandingSection />
      {/* <Header /> */}
      
      <DisplayProjects />
      <AboutSection />
      {/* <AnnouncementBanner /> */}
      {/* <ServicesSection /> */}
      {/* <Map /> */}
      <Partners />
      <Socials />
      <Footer />
    </div>
  );
}
export default Home;
